import { Box, Button, Paper } from '@material-ui/core';
import Close from '@material-ui/icons/Close';
import Info from '@material-ui/icons/Info';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import {
	AppState,
	Attachment,
	attachmentEditorSelectAttachment,
	pushMessage
} from '../../../redux';
import { Body1 } from '../../atoms';

import './attachment-location-changer.styles.scss';

export interface IAttachmentLocationChangerOwnProps {
	onSave: (attachment: Attachment) => void;
}

export interface IAttachmentLocationChangerStateProps {
	currentAttachment?: Attachment;
	resetLocation: () => void;
	pushMessage: (message: string) => void;
}

function AttachmentLocationChangerView(
	props: IAttachmentLocationChangerOwnProps &
		IAttachmentLocationChangerStateProps
): ReactElement {
	const { currentAttachment, resetLocation, pushMessage, onSave } = props;
	const { t } = useTranslation(['general', 'map']);

	function handleSave(): void {
		if (!currentAttachment) return;
		onSave(currentAttachment);
		pushMessage(t('map:attachments.location.movedPin'));
		resetLocation();
	}

	return (
		<Paper square className="attachment-location-changer">
			<Button onClick={resetLocation} variant="outlined" color="primary">
				<Close />
				{t('general:dialog.cancel')}
			</Button>
			<Box className="attachment-location-changer-info">
				<Info />
				<Body1>{t('map:attachments.location.movePinAndSave')}</Body1>
			</Box>
			<Button onClick={handleSave} variant="contained" color="primary">
				{t('map:attachments.location.saveLocation')}
			</Button>
		</Paper>
	);
}

function mapStateToProps(state: AppState) {
	return {
		currentAttachment: state.attachmentsEditor.currentAttachment
	};
}

function mapDispatchToProps(dispatch: Dispatch) {
	return {
		resetLocation: () => dispatch(attachmentEditorSelectAttachment()),
		pushMessage: (message: string) => dispatch(pushMessage(message))
	};
}

export const AttachmentLocationChanger = connect(
	mapStateToProps,
	mapDispatchToProps
)(AttachmentLocationChangerView);
